import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import {
  Bau365DataAccessNewsfeedModule,
  RootNewsfeedResolver,
  SubscriptionNewsfeedResolver,
  UserHistoryNewsfeedResolver,
} from '@planone/bau365/data-access-newsfeed';
import { Bau365FeatureBreadcrumbModule } from '@planone/bau365/feature-breadcrumb';
// eslint-disable-next-line
import { Bau365FeatureEventsSharedModule } from '@planone/bau365/feature-events';
import { Bau365FeatureExhibitorsSharedModule } from '@planone/bau365/feature-exhibitors';
import { Bau365FeaturePostsSharedModule } from '@planone/bau365/feature-posts';
import { Bau365FeatureProductsSharedModule } from '@planone/bau365/feature-products';
import { Bau365UiShellModule } from '@planone/bau365/ui-shell';
import { SharedUtilFeatureFlagsModule } from '@planone/shared/data-access-feature-flags';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUiGridModule } from '@planone/shared/ui-grid';

import { PageNewsfeedComponent } from './page-newsfeed/page-newsfeed.component';
import { ChannelGroupComponent } from './section-channels/channel-group/channel-group.component';
import { ChannelCountBadgeComponent } from './section-channels/channel-list-item/channel-count-badge/channel-count-badge.component';
import { ChannelListItemComponent } from './section-channels/channel-list-item/channel-list-item.component';
import { DividerComponent } from './section-channels/divider/divider.component';
import { SectionChannelsComponent } from './section-channels/section-channels.component';
import { QuicklinksComponent } from './section-header/quicklinks/quicklinks.component';
import { SearchTriggerComponent } from './section-header/search-trigger/search-trigger.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { UserSalutationComponent } from './section-header/user-salutation/user-salutation.component';
import { SectionLoadMoreComponent } from './section-load-more/section-load-more.component';
import { SectionLoadingComponent } from './section-loading/section-loading.component';
import { SectionNoResultsComponent } from './section-no-results/section-no-results.component';
import { ResultTeaserComponent } from './section-result-list/result-teaser/result-teaser.component';
import { SectionResultListComponent } from './section-result-list/section-result-list.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        resolve: { channel: RootNewsfeedResolver },
        component: PageNewsfeedComponent,
        pathMatch: 'full',
        data: { analyticsPageType: 'newsfeed' },
      },
      {
        path: 'subscription/:fair_id/:exhibitor_id',
        component: PageNewsfeedComponent,
        resolve: { channel: SubscriptionNewsfeedResolver },
        data: { analyticsPageType: 'newsfeed' },
      },
      {
        path: 'history',
        component: PageNewsfeedComponent,
        resolve: { channel: UserHistoryNewsfeedResolver },
        data: { analyticsPageType: 'newsfeed' },
      },
    ]),
    MatIconModule,
    MatButtonModule,
    Bau365DataAccessNewsfeedModule,
    Bau365FeatureExhibitorsSharedModule,
    Bau365FeatureProductsSharedModule,
    Bau365FeatureEventsSharedModule,
    Bau365FeaturePostsSharedModule,
    Bau365UiShellModule,
    Bau365FeatureBreadcrumbModule,
    SharedUtilFeatureFlagsModule,
    SharedUiGridModule,
    SharedUiElementsModule,
    MatChipsModule,
    MatBadgeModule,
  ],
  providers: [RootNewsfeedResolver, SubscriptionNewsfeedResolver, UserHistoryNewsfeedResolver],
  declarations: [
    PageNewsfeedComponent,
    SectionHeaderComponent,
    SectionResultListComponent,
    SectionLoadMoreComponent,
    SectionNoResultsComponent,
    SearchTriggerComponent,
    UserSalutationComponent,
    SectionChannelsComponent,
    ChannelListItemComponent,
    ChannelGroupComponent,
    QuicklinksComponent,
    SectionLoadingComponent,
    ChannelCountBadgeComponent,
    DividerComponent,
    ResultTeaserComponent,
  ],
})
export class Bau365FeatureNewsfeedModule {}
